import React from 'react';

// PeriodPills — sélecteur compact de période pour le dashboard et les rapports.
// Calcule from/to en local (timezone du navigateur) puis appelle
// onChange({ from, to, key, label }).
//
// Presets : aujourd'hui, hier, 7 jours, 30 jours, ce mois, mois dernier.

const fmtISO = (d) => {
  // YYYY-MM-DD en tz locale — évite le décalage UTC qui transforme 23h59
  // en demain matin selon le fuseau.
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const j = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${j}`;
};

export function getPeriodRange(key) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  switch (key) {
    case 'today': {
      const iso = fmtISO(today);
      return { key, label: "Aujourd'hui", from: iso, to: iso };
    }
    case 'yesterday': {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      const iso = fmtISO(y);
      return { key, label: 'Hier', from: iso, to: iso };
    }
    case '7d': {
      const from = new Date(today);
      from.setDate(from.getDate() - 6); // 7 jours incluant aujourd'hui
      return { key, label: '7 jours', from: fmtISO(from), to: fmtISO(today) };
    }
    case '30d': {
      const from = new Date(today);
      from.setDate(from.getDate() - 29);
      return { key, label: '30 jours', from: fmtISO(from), to: fmtISO(today) };
    }
    case 'this_month': {
      const from = new Date(today.getFullYear(), today.getMonth(), 1);
      return { key, label: 'Ce mois', from: fmtISO(from), to: fmtISO(today) };
    }
    case 'last_month': {
      const from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const to   = new Date(today.getFullYear(), today.getMonth(), 0); // dernier jour du mois précédent
      return { key, label: 'Mois dernier', from: fmtISO(from), to: fmtISO(to) };
    }
    default:
      return getPeriodRange('today');
  }
}

const PRESETS = [
  { key: 'today',      label: "Aujourd'hui" },
  { key: 'yesterday',  label: 'Hier' },
  { key: '7d',         label: '7 jours' },
  { key: '30d',        label: '30 jours' },
  { key: 'this_month', label: 'Ce mois' },
  { key: 'last_month', label: 'Mois dernier' },
];

export default function PeriodPills({ value = 'today', onChange }) {
  const handle = (key) => {
    if (key === value) return;
    onChange?.(getPeriodRange(key));
  };
  return (
    <div className="flex items-center gap-1 overflow-x-auto -mx-1 px-1 py-0.5 no-scrollbar">
      {PRESETS.map((p) => {
        const active = value === p.key;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => handle(p.key)}
            className={[
              'flex-shrink-0 px-3 py-1.5 rounded-lg text-xs font-medium transition-all whitespace-nowrap',
              active
                ? 'bg-yellow-500 text-gray-950'
                : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white',
            ].join(' ')}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
